import useOrders from "../../../state/ordering/useOrders";
import {idempiereDate} from "../../../../res/dataServices/idempiereDate";
import SkeletonDiv from "../../../general/loading/SkeletonDiv";
import HeaderSkeleton from "../ordering/HeaderSkeleton";
import HeaderShipment from "../ordering/HeaderShipment";
import HeaderOrder from "../ordering/HeaderOrder";
import {useState} from "react";
import RangeSelector from "../../../account/component/RangeSelector";

const DEFAULT_MONTHS = 12;
const DEFAULT_DATE = idempiereDate.getXMonthsAgo(DEFAULT_MONTHS);
const DEFAULT_START = "'" + idempiereDate.getDateString(DEFAULT_DATE) + "'";
const DEFAULT_END = "'" + idempiereDate.getDateString(new Date()) + "'"
const DEFAULT_LIMIT = 10;

const displayOrderType = (orderInfo, name) => {
    return orderInfo[name]
        && orderInfo[name].length > 0;
}

const ActiveShipments = ({ shipments }) => {
    if(!shipments || shipments.length === 0) return null;

    return (
        <div className="account-view-list">
            <p className="account-heading-large">Active Shipments</p>
            {shipments.map((e,i) =>
                <HeaderShipment key={i} shipment={e}/>
            )}
        </div>
    )
}

const OrderList = ({ordering, name, deliveries, getOrderLinks}) => {

    if(!deliveries || deliveries.length === 0) {
        return null;
    }

    return (
        <div className="account-view-list">
            <p className="account-heading-large">{name}</p>
            {deliveries.map((o,i) => {
                const links = getOrderLinks(o, ordering);
                return (<HeaderOrder key={i} order={o} shipments={links.shipments} invoices={links.invoices}/>)
            })}
        </div>
    )
}

const AccountLayoutOrders = () => {

    const [ reloaded, setReloaded ] = useState(false);

    const {
        orders,
        ordering,
        deliveryList,
        orderInfo,
        loading,
        fetchedDates,
        getActiveShipments,
        getOrdersByDate,
        getOrderLinks
    } = useOrders(DEFAULT_START, DEFAULT_END);

    if(!reloaded) {
        setReloaded(true);
        getOrdersByDate(DEFAULT_START, DEFAULT_END, DEFAULT_LIMIT);
        getActiveShipments();
    }

    const displayLoading = loading.order;
    const displayNoOrders = !orders ||
        !(displayOrderType(orderInfo, "outForDelivery")
            || displayOrderType(orderInfo, "pending")
            || displayOrderType(orderInfo, "completed"))



    const onRangeRequest = (startDate, endDate) => {
        if(!displayLoading) {

            const idStartDate = `'${idempiereDate.getDateString(startDate)}'`;
            const idEndDate   = `'${idempiereDate.getDateString(endDate)}'`;

            if(!fetchedDates || !(fetchedDates.startDate === idStartDate && fetchedDates.endDate)) {
                getOrdersByDate(idStartDate, idEndDate);
            }
        }
    }

    return (
        <>
            <h1>Orders</h1>
            <RangeSelector
                maxDates={DEFAULT_MONTHS}
                buttonText="Load Orders"
                loading={displayNoOrders}
                onRequest={onRangeRequest}
            />
            <ActiveShipments shipments={deliveryList} />
            {displayLoading &&
                <div className="account-view-list">
                    <SkeletonDiv style={{height: "2.2em", width:"300pt"}}/>
                    {[...Array(4).keys()].map((e,i) =>
                        <HeaderSkeleton v key={i} />
                    )}
                </div>
            }
            {displayNoOrders &&
                <div className="account-view-list">
                    <p className="account-heading-large">No orders</p>
                    {/* TODO show message for when they have no orders for the default time period*/}
                    <p>We could not find any orders for that time period</p>
                </div>
            }
            {!displayNoOrders && !displayLoading &&
                <>
                    <OrderList
                        ordering={ordering}
                        getOrderLinks={getOrderLinks}
                        name="In Progress"
                        deliveries={orderInfo.outForDelivery} />
                    <OrderList
                        ordering={ordering}
                        getOrderLinks={getOrderLinks}
                        name="Pending"
                        deliveries={orderInfo.pending} />
                    <OrderList
                        ordering={ordering}
                        getOrderLinks={getOrderLinks}
                        name="Delivered"
                        deliveries={orderInfo.completed} />
                </>
            }
        </>
    )

}

export default AccountLayoutOrders;
